import React, { useEffect, useState } from "react";
import './styles.css'
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import SubTextLabel from "../../../components/label/sub-text-label/subTextLabel";
import Select from 'react-select'
import {
    addEmployeeRequest, addEmployeeRequestStatus, employeeLoginCodeCheckRequest,
    clearEmployeeLoginCodeCheck, employeeListRequest
} from '../../../redux/employee/employee.action'
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, isValidEmail } from "../../../utils/Utils";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Modal from 'react-bootstrap/Modal';
import CommonCheckbox from "../../../components/common-checkbox/commonCheckbox";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import PercentInputHalf from "../../../components/input/percent-input-half/percentInputHalf";

const AddEmployee = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { addEmployeeSuccess, addEmployeeError, addEmployeeReqStatus,
        loginCodeCheckSuccess, loginCodeCheckError, employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [personalEmail, setPersonalEmail] = useState('')
    const [employeeCode, setEmployeeCode] = useState('')
    const [employeeLoginCode, setEmployeeLoginCode] = useState('')
    const [mobile, setMobile] = useState()
    const [role, setRole] = useState('')
    const [employeeType, setEmployeeType] = useState()
    const [employeeSalary, setEmployeeSalary] = useState('')
    const [employeeSalaryType, setEmployeeSalaryType] = useState()
    const employeeTypeList = [
        { key: 'FULL_TIME', value: 'Full Time' },
        { key: 'CONTRACTUAL', value: 'Contractual' },
        { key: 'PROJECT_BASED', value: 'Project Based' },
    ]
    const employeeSalaryTypeList = [
        { key: 'ANUALLY', value: 'Anually' },
        { key: 'MONTHLY', value: 'Monthly' },
        { key: 'HOURLY', value: 'Hourly' },
        { key: 'FIXED', value: 'Fixed' },
    ]
    const [isAddDeduction, setIsAddDeduction] = useState(false)
    const [deductionLabel, setDeductionLabel] = useState('')
    const [deductionValue, setDeductionValue] = useState('')
    const [isDeductionTypeFixed, setIsDeductionTypeFixed] = useState(false)
    const [isDeductionTypePercent, setIsDeductionTypePercent] = useState(false)
    const [deductionList, setDeductionList] = useState([])
    const [loginCodeEditCount, setLoginCodeEditCount] = useState(0)
    const [addEmployeeSuccessModel, setAddEmployeeSuccessModel] = useState(false)
    const [isAssignManagerCheck, setIsAssignManagerCheck] = useState(false)
    const [selectedManager, setSelectedManager] = useState(null)
    const [showEmployeeModal, setShowEmployeeModal] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [startDate, setStartDate] = useState(new Date())

    const [isLocationPermission, setIsLocationPermission] = useState(false)
    const [viewAllLocationPermission, setViewAllLocationPermission] = useState(false)
    const [addLocationPermission, setAddLocationPermission] = useState(false)
    const [updateLocationPermission, setUpdateLocationPermission] = useState(false)

    const [isEmployeePermission, setIsEmployeePermission] = useState(false)
    const [addEmployeePermission, setAddEmployeePermission] = useState(false)
    const [removeEmployeePermission, setRemoveEmployeePermission] = useState(false)
    const [updateEmployeePerPermission, setUpdateEmployeePerPermission] = useState(false)

    const [isProjectPermission, setIsProjectPermission] = useState(false)
    const [addProjectPermission, setAddProjectPermission] = useState(false)
    const [updateProjectPermission, setUpdateProjectPermission] = useState(false)
    const [viewProjectCostingPermission, setViewProjectCostingPermission] = useState(false)
    const [updateProjectEmployeeRequestPermission, setUpdateProjectEmployeeRequestPermission] = useState(false)

    const [isShiftPermission, setIsShiftPermission] = useState(false)
    const [addShiftPermission, setAddShiftPermission] = useState(false)
    const [updateShiftDetailsPermission, setUpdateShiftDetailPermission] = useState(false)
    const [updateShiftEmployeeRequestPermission, setUpdateShiftEmployeeRequestPermission] = useState(false)

    const [isTaskPermission, setIsTaskPermission] = useState(false)
    const [addTaskPermission, setAddTaskPermission] = useState(false)
    const [assignTaskPermission, setAssignTaskPermission] = useState(false)
    const [removeEmployeeTaskPermission, setRemoveEmployeeTaskPermission] = useState(false)

    const [isRequestPermission, setIsRequestPermission] = useState(false)
    const [acceptOrRejectRequestPermission, setAcceptOrRejectRequestPermission] = useState(false)

    const [isDocumentPermission, setIsDocumentPermission] = useState(false)
    const [addDocumentPermission, setAddDocumentPermission] = useState(false)

    const [isPolicyPermission, setIsPolicyPermission] = useState(false)
    const [addPolicyPermission, setAddPolicyPermission] = useState(false)

    const [isAssetPermission, setIsAssetPermission] = useState(false)
    const [viewAllAssetsPermission, setViewAllAssetsPermission] = useState(false)
    const [addAssetPermission, setAddAssetPermission] = useState(false)
    const [assignAssetPermission, setAssignAssetPermission] = useState(false)
    const [updateAssetPermission, setUpdateAssetPermission] = useState(false)

    const [isAuditPermission, setIsAuditPermission] = useState(false)
    const [viewAllAuditPermission, setViewAllAuditPermission] = useState(false)
    const [newAuditPermission, setNewAuditPermission] = useState(false)
    const [updateAuditStatusPermission, setUpdateAuditPermission] = useState(false)
    const [assignAuditPermission, setAssignAuditPermission] = useState(false)

    const [isVisitorPermission, setIsVistorPermission] = useState(false)
    const [viewVisitorBookPermission, setViewVisitorBookPermission] = useState(false)
    const [updateVisitorFormSettingPermission, setUpdateVisitorFormSettingPermission] = useState(false)

    const [isPayrollPermission, setIsPayrollPermission] = useState(false)
    const [manageTaxRulePermission, setManageTaxRulePermission] = useState(false)
    const [manageEmployeePayrollPermission, setManageEmployeePayrollPermission] = useState(false)

    const [isSuppliesPermission, setIsSuppliesPermission] = useState(false)
    const [addMerchantPermission, setAddMerchantPermission] = useState(false)
    const [manageMerchantPermission, setManageMerchantPermission] = useState(false)
    const [viewCategoriesPermission, setViewCategoriesPermission] = useState(false)
    const [addCategoriesPermission, setAddCategoriesPermission] = useState(false)
    const [viewItemPermission, setViewItemPermission] = useState(false)
    const [addItemPermission, setAddItemPermission] = useState(false)
    const [manageItemPermission, setManageItemPermission] = useState(false)

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_EMPLOYEE, true)
            fetchBusinessList()
        }
    }, [])

    useEffect(() => {
        if (addEmployeeReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            setAddEmployeeSuccessModel(true)
            clearFields()
        } else if (addEmployeeReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(addEmployeeError.message)
        }
        if (addEmployeeReqStatus?.length) {
            dispatch(addEmployeeRequestStatus(''))
        }
    }, [addEmployeeSuccess, addEmployeeError, addEmployeeReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.ADD_EMPLOYEE) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.ADD_EMPLOYEE, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (!isEmpty(loginCodeCheckSuccess)) {
            setLoading(false)
            if (!loginCodeCheckSuccess.data.isLoginCodeAvailable) {
                displayErrorToast(loginCodeCheckSuccess.data.message)
            } else {
                displaySuccessToast(loginCodeCheckSuccess.data.message)
            }
        } else if (!isEmpty(loginCodeCheckError)) {
            setLoading(false)
            displayErrorToast(loginCodeCheckError.message)
        }
    }, [loginCodeCheckSuccess, loginCodeCheckError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {}
        if (isLoggedInUserBusiness(user)) {
            if (!isEmpty(selectedBusiness)) {
                data.businessId = selectedBusiness.businessId
                // data.locationId = selectedLocation.locationId
            }
        } else if (isLoggedInUserEmployee(user)) {
            data.businessId = employeeSelectedBusiness
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    const clearFields = () => {
        setFirstName('')
        setLastName('')
        setPersonalEmail('')
        setEmployeeCode('')
        setEmployeeLoginCode('')
        setRole('')
        setEmployeeSalary('')
        dispatch(clearEmployeeLoginCodeCheck(''))
        setSelectedManager(null)
        setSearchQuery('')
        setShowEmployeeModal(false)
        setIsLocationPermission(false)
        setViewAllLocationPermission(false)
        setAddLocationPermission(false)
        setUpdateLocationPermission(false)
        setIsEmployeePermission(false)
        setAddEmployeePermission(false)
        setRemoveEmployeePermission(false)
        setUpdateEmployeePerPermission(false)
        setIsProjectPermission(false)
        setAddProjectPermission(false)
        setUpdateProjectPermission(false)
        setViewProjectCostingPermission(false)
        setUpdateProjectEmployeeRequestPermission(false)
        setIsShiftPermission(false)
        setAddShiftPermission(false)
        setUpdateShiftDetailPermission(false)
        setUpdateShiftEmployeeRequestPermission(false)
        setIsTaskPermission(false)
        setAddTaskPermission(false)
        setAssignTaskPermission(false)
        setRemoveEmployeeTaskPermission(false)
        setIsRequestPermission(false)
        setAcceptOrRejectRequestPermission(false)
        setIsDocumentPermission(false)
        setAddDocumentPermission(false)
        setIsPolicyPermission(false)
        setAddPolicyPermission(false)
        setIsAssignManagerCheck(false)
        setEmployeeSalaryType(undefined)
        setEmployeeType(undefined)
        setSelectedManager(null)
        setIsAssetPermission(false)
        setViewAllAssetsPermission(false)
        setAddAssetPermission(false)
        setAssignAssetPermission(false)
        setUpdateAssetPermission(false)
        setIsAddDeduction(false)
        setIsDeductionTypeFixed(false)
        setIsDeductionTypePercent(false)
        setDeductionLabel('')
        setDeductionValue('')
        setDeductionList([])
        setIsAuditPermission(false)
        setViewAllAuditPermission(false)
        setNewAuditPermission(false)
        setUpdateAuditPermission(false)
        setAssignAuditPermission(false)
        setIsVistorPermission(false)
        setViewVisitorBookPermission(false)
        setUpdateVisitorFormSettingPermission(false)
        setIsPayrollPermission(false)
        setManageTaxRulePermission(false)
        setManageEmployeePayrollPermission(false)
        setIsSuppliesPermission(false)
        setAddMerchantPermission(false)
        setManageMerchantPermission(false)
        setViewCategoriesPermission(false)
        setAddCategoriesPermission(false)
        setViewItemPermission(false)
        setAddItemPermission(false)
        setManageItemPermission(false)
    }

    const handleSubmitClick = () => {
        if (isEmpty(firstName)) {
            displayErrorToast('First name cannot be blank')
        } else if (isEmpty(lastName)) {
            displayErrorToast('Last name cannot be blank')
        } else if (isEmpty(personalEmail)) {
            displayErrorToast('Employee personal email cannot be blank')
        } else if (!isValidEmail(personalEmail)) {
            displayErrorToast('Invalid email id')
        } else if (isNull(mobile)) {
            displayErrorToast('Mobile number cannot be blank')
        } else if (isEmpty(employeeCode)) {
            displayErrorToast('Employee code cannot be blank')
        } else if (isEmpty(role)) {
            displayErrorToast('Employee role cannot be blank')
        } else if (isEmpty(employeeLoginCode)) {
            displayErrorToast('Employee login code cannot be blank')
        } else if (isEmpty(loginCodeCheckSuccess)) {
            displayErrorToast('Please check employee login code availability')
        } else if (!isEmpty(loginCodeCheckSuccess.data) && loginCodeCheckSuccess.data.isLoginCodeAvailable === false) {
            displayErrorToast('Employee login code already in use. Please try with different login code.')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness)) {
            displayErrorToast('Business not selected')
        } else if (isLoggedInUserBusiness(user) && isEmpty(selectedLocation)) {
            displayErrorToast('Business location not selected')
        } else if (isEmpty(employeeType)) {
            displayErrorToast('Employee Type cannot be blank')
        } else if (isAssignManagerCheck === true && isEmpty(selectedManager)) {
            displayErrorToast('Manager/Supervisor not selected. Please try again.')
        } else if (isEmpty(employeeSalary)) {
            displayErrorToast('Employee salary cannot be blank')
        } else if (isEmpty(employeeSalaryType)) {
            displayErrorToast('Employee salary type cannot be blank')
        } else if (isAddDeduction === true && isEmpty(deductionList)) {
            displayErrorToast('Salary deduction not added')
        } else {
            setLoading(true)
            const mobileWithPlusSymbol = mobile.replace('+', "")
            const data = {
                businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation,
                firstName: firstName,
                lastName: lastName,
                personalEmail: personalEmail,
                mobile: parseInt(mobileWithPlusSymbol),
                employeeCode: employeeCode,
                employeeLoginCode: employeeLoginCode,
                productCode: APP_CONSTANTS.PRODUCT_NAME,
                role: role,
                employeeType: employeeType.key
            }
            if (isAssignManagerCheck === true) {
                data.supervisorId = selectedManager.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? selectedManager.employeeId : selectedManager.userId
                data.supervisorType = selectedManager.userType
            }
            if (!isEmpty(startDate)) {
                data.startDate = startDate
            }

            data.salaryDetails = {
                businessId: selectedBusiness.businessId,
                locationId: selectedLocation.locationId,
                salary: employeeSalary,
                employeeSalaryType: employeeSalaryType.key,
                ...(isAddDeduction === true && { deductions: deductionList })
            }

            const empPermissions = []
            if (isLocationPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.LOCATION,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.LOCATION.VIEW_ALL_LOCATIONS] = viewAllLocationPermission
                obj[PERMISSION_SUB_TYPE.LOCATION.ADD_LOCATION] = addLocationPermission
                obj[PERMISSION_SUB_TYPE.LOCATION.UPDATE_LOCATION] = updateLocationPermission
                empPermissions.push(obj)
            }
            if (isEmployeePermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.EMPLOYEE,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.EMPLOYEE.ADD_EMPLOYEE] = addEmployeePermission
                obj[PERMISSION_SUB_TYPE.EMPLOYEE.REMOVE_EMPLOYEE] = removeEmployeePermission
                obj[PERMISSION_SUB_TYPE.EMPLOYEE.UPDATE_EMPLOYEE] = updateEmployeePerPermission
                empPermissions.push(obj)
            }
            if (isProjectPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.PROJECT,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.PROJECT.ADD_PROJECT] = addProjectPermission
                obj[PERMISSION_SUB_TYPE.PROJECT.UPDATE_DETAILS] = updateProjectPermission
                obj[PERMISSION_SUB_TYPE.PROJECT.VIEW_COSTING] = viewProjectCostingPermission
                obj[PERMISSION_SUB_TYPE.PROJECT.ACCEPT_REJECT_EMPLOYEE_REQUEST] = updateProjectEmployeeRequestPermission
                empPermissions.push(obj)
            }
            if (isShiftPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.SHIFT,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.SHIFT.ADD_SHIFT] = addShiftPermission
                obj[PERMISSION_SUB_TYPE.SHIFT.UPDATE_SHIFT] = updateShiftDetailsPermission
                obj[PERMISSION_SUB_TYPE.SHIFT.ACCEPT_REJECT_EMPLOYEE_REQUEST] = updateShiftEmployeeRequestPermission
                empPermissions.push(obj)
            }
            if (isTaskPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.TASK,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.TASK.ADD_TASK] = addTaskPermission
                obj[PERMISSION_SUB_TYPE.TASK.ASSIGN_TASK] = assignTaskPermission
                obj[PERMISSION_SUB_TYPE.TASK.REMOVE_EMPLOYEE_TASK] = removeEmployeeTaskPermission
                empPermissions.push(obj)
            }
            if (isRequestPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.REQUEST,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.REQUEST.ACCEPT_REJECT_REQUEST] = acceptOrRejectRequestPermission
                empPermissions.push(obj)
            }
            if (isDocumentPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.DOCUMENTS,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.DOCUMENTS.ADD_DOCUMENT] = addDocumentPermission
                empPermissions.push(obj)
            }
            if (isPolicyPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.POLICIES,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.POLICIES.ADD_POLICY] = addPolicyPermission
                empPermissions.push(obj)
            }
            if (isAssetPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.ASSET,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.ASSET.ADD_ASSET] = addAssetPermission
                obj[PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET] = assignAssetPermission
                obj[PERMISSION_SUB_TYPE.ASSET.UPDATE_ASSET] = updateAssetPermission
                obj[PERMISSION_SUB_TYPE.ASSET.VIEW_ALL_ASSET] = viewAllAssetsPermission
                empPermissions.push(obj)
            }
            if (isAuditPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.AUDIT,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.AUDIT.ASSIGN_AUDIT] = assignAuditPermission
                obj[PERMISSION_SUB_TYPE.AUDIT.UPDATE_AUDIT_STATUS] = updateAuditStatusPermission
                obj[PERMISSION_SUB_TYPE.AUDIT.ADD_AUDIT] = newAuditPermission
                obj[PERMISSION_SUB_TYPE.AUDIT.VIEW_ALL_AUDIT] = viewAllAuditPermission
                empPermissions.push(obj)
            }
            if (isVisitorPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.VISITOR,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.VISITOR.VIEW_VISITOR_BOOK] = viewVisitorBookPermission
                obj[PERMISSION_SUB_TYPE.VISITOR.UPDATE_ENTRY_SETTINGS] = updateVisitorFormSettingPermission
                empPermissions.push(obj)
            }
            if (isPayrollPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.PAYROLL,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.PAYROLL.MANAGE_TAX_RULES] = manageTaxRulePermission
                obj[PERMISSION_SUB_TYPE.PAYROLL.MANAGE_EMPLOYEE_PAYROLL] = manageEmployeePayrollPermission
                empPermissions.push(obj)
            }
            if (isSuppliesPermission === true) {
                let obj = {
                    type: PERMISSION_TYPE.SUPPLIES,
                    businessId: isLoggedInUserBusiness(user) === true ? selectedBusiness.businessId : employeeSelectedBusiness,
                    locationId: isLoggedInUserBusiness(user) === true ? selectedLocation.locationId : employeeSelectedLocation
                }
                obj[PERMISSION_SUB_TYPE.SUPPLIES.ADD_MERCHANT] = addMerchantPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_MERCHANT] = manageMerchantPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.VIEW_CATEGORIES] = viewCategoriesPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.ADD_CATEGORY] = addCategoriesPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.VIEW_ITEM] = viewItemPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.ADD_ITEM] = addItemPermission
                obj[PERMISSION_SUB_TYPE.SUPPLIES.MANAGE_ITEM] = manageItemPermission
                empPermissions.push(obj)
            }
            data.permissions = empPermissions

            dispatch(addEmployeeRequest(data))
        }
    }

    const handleEmployeeLoginCodeChange = (e) => {
        const value = e.target.value
        if (employeeLoginCode !== value) {
            setLoginCodeEditCount((prev) => prev + 1)
        }
        setEmployeeLoginCode(value)
        if (loginCodeEditCount >= 1) {
            dispatch(clearEmployeeLoginCodeCheck(''))
        }
    }

    const handleLoginCodeVerifyCheckClick = () => {
        if (isEmpty(employeeLoginCode)) {
            displayErrorToast('Emplloyee login code cannot be blank')
        } else {
            setLoading(true)
            const data = {
                employeeLoginCode: employeeLoginCode
            }
            dispatch(employeeLoginCodeCheckRequest(data))
        }
    }

    const handleSelectManagerClick = () => {
        setSelectedManager(null)
        setSearchQuery('')
        setShowEmployeeModal(true)
        fetchEmployeeList()
    }

    useEffect(() => {
        if (isLocationPermission === true) {
            setViewAllLocationPermission(true)
            setAddLocationPermission(true)
            setUpdateLocationPermission(true)
        } else {
            setViewAllLocationPermission(false)
            setAddLocationPermission(false)
            setUpdateLocationPermission(false)
        }
    }, [isLocationPermission])

    useEffect(() => {
        if (isEmployeePermission === true) {
            setAddEmployeePermission(true)
            setRemoveEmployeePermission(true)
            setUpdateEmployeePerPermission(true)
        } else {
            setAddEmployeePermission(false)
            setRemoveEmployeePermission(false)
            setUpdateEmployeePerPermission(false)
        }
    }, [isEmployeePermission])

    useEffect(() => {
        if (isProjectPermission === true) {
            setAddProjectPermission(true)
            setUpdateProjectPermission(true)
            setViewProjectCostingPermission(true)
            setUpdateProjectEmployeeRequestPermission(true)
        } else {
            setAddProjectPermission(false)
            setUpdateProjectPermission(false)
            setViewProjectCostingPermission(false)
            setUpdateProjectEmployeeRequestPermission(false)
        }
    }, [isProjectPermission])

    useEffect(() => {
        if (isShiftPermission === true) {
            setAddShiftPermission(true)
            setUpdateShiftDetailPermission(true)
            setUpdateShiftEmployeeRequestPermission(true)
        } else {
            setAddShiftPermission(false)
            setUpdateShiftDetailPermission(false)
            setUpdateShiftEmployeeRequestPermission(false)
        }
    }, [isShiftPermission])

    useEffect(() => {
        if (isTaskPermission === true) {
            setAddTaskPermission(true)
            setAssignTaskPermission(true)
            setRemoveEmployeeTaskPermission(true)
        } else {
            setAddTaskPermission(false)
            setAssignTaskPermission(false)
            setRemoveEmployeeTaskPermission(false)
        }
    }, [isTaskPermission])

    useEffect(() => {
        if (isRequestPermission === true) {
            setAcceptOrRejectRequestPermission(true)
        } else {
            setAcceptOrRejectRequestPermission(false)
        }
    }, [isRequestPermission])

    useEffect(() => {
        if (isDocumentPermission === true) {
            setAddDocumentPermission(true)
        } else {
            setAddDocumentPermission(false)
        }
    }, [isDocumentPermission])

    useEffect(() => {
        if (isPolicyPermission === true) {
            setAddPolicyPermission(true)
        } else {
            setAddPolicyPermission(false)
        }
    }, [isPolicyPermission])

    useEffect(() => {
        if (isAssetPermission === true) {
            setViewAllAssetsPermission(true)
            setAddAssetPermission(true)
            setAssignAssetPermission(true)
            setUpdateAssetPermission(true)
        } else {
            setViewAllAssetsPermission(false)
            setAddAssetPermission(false)
            setAssignAssetPermission(false)
            setUpdateAssetPermission(false)
        }
    }, [isAssetPermission])

    useEffect(() => {
        if (isAuditPermission === true) {
            setViewAllAuditPermission(true)
            setNewAuditPermission(true)
            setUpdateAuditPermission(true)
            setAssignAuditPermission(true)
        } else {
            setViewAllAuditPermission(false)
            setNewAuditPermission(false)
            setUpdateAuditPermission(false)
            setAssignAuditPermission(false)
        }
    }, [isAuditPermission])

    useEffect(() => {
        if (isVisitorPermission === true) {
            setViewVisitorBookPermission(true)
            setUpdateVisitorFormSettingPermission(true)
        } else {
            setViewVisitorBookPermission(false)
            setUpdateVisitorFormSettingPermission(false)
        }
    }, [isVisitorPermission])

    useEffect(() => {
        if (isPayrollPermission === true) {
            setManageTaxRulePermission(true)
            setManageEmployeePayrollPermission(true)
        } else {
            setManageTaxRulePermission(false)
            setManageEmployeePayrollPermission(false)
        }
    }, [isPayrollPermission])

    useEffect(() => {
        if (isSuppliesPermission === true) {
            setAddMerchantPermission(true)
            setManageMerchantPermission(true)
            setViewCategoriesPermission(true)
            setAddCategoriesPermission(true)
            setViewItemPermission(true)
            setAddItemPermission(true)
            setManageItemPermission(true)
        } else {
            setAddMerchantPermission(false)
            setManageMerchantPermission(false)
            setViewCategoriesPermission(false)
            setAddCategoriesPermission(false)
            setViewItemPermission(false)
            setAddItemPermission(false)
            setManageItemPermission(false)
        }
    }, [isSuppliesPermission])

    useEffect(() => {
        if (viewAllLocationPermission === false && addLocationPermission === false && updateLocationPermission === false) {
            setIsLocationPermission(false)
        }
    }, [viewAllLocationPermission, addLocationPermission, updateLocationPermission])

    useEffect(() => {
        if (addEmployeePermission === false && removeEmployeePermission === false && updateEmployeePerPermission === false) {
            setIsEmployeePermission(false)
        }
    }, [addEmployeePermission, removeEmployeePermission, updateEmployeePerPermission])

    useEffect(() => {
        if (addProjectPermission === false && updateProjectPermission === false && viewProjectCostingPermission === false && updateProjectEmployeeRequestPermission === false) {
            setIsProjectPermission(false)
        }
    }, [addProjectPermission, updateProjectPermission, viewProjectCostingPermission, updateProjectEmployeeRequestPermission])

    useEffect(() => {
        if (addShiftPermission === false && updateShiftDetailsPermission === false && updateShiftEmployeeRequestPermission === false) {
            setIsShiftPermission(false)
        }
    }, [addShiftPermission, updateShiftDetailsPermission, updateShiftEmployeeRequestPermission])

    useEffect(() => {
        if (addTaskPermission === false && assignTaskPermission === false && removeEmployeeTaskPermission === false) {
            setIsTaskPermission(false)
        }
    }, [addTaskPermission, assignTaskPermission, removeEmployeeTaskPermission])

    useEffect(() => {
        if (acceptOrRejectRequestPermission === false) {
            setIsRequestPermission(false)
        }
    }, [acceptOrRejectRequestPermission])

    useEffect(() => {
        if (addDocumentPermission === false) {
            setIsDocumentPermission(false)
        }
    }, [addDocumentPermission])

    useEffect(() => {
        if (addPolicyPermission === false) {
            setIsPolicyPermission(false)
        }
    }, [addPolicyPermission])

    useEffect(() => {
        if (viewAllAssetsPermission === false && addAssetPermission === false && assignAssetPermission === false && updateAssetPermission === false) {
            setIsAssetPermission(false)
        }
    }, [viewAllAssetsPermission, addAssetPermission, assignAssetPermission, updateAssetPermission])

    useEffect(() => {
        if (viewAllAuditPermission === false && newAuditPermission === false && updateAuditStatusPermission === false && assignAuditPermission === false) {
            setIsAuditPermission(false)
        }
    }, [viewAllAuditPermission, newAuditPermission, updateAuditStatusPermission, assignAuditPermission])

    useEffect(() => {
        if (viewVisitorBookPermission === false && updateVisitorFormSettingPermission === false) {
            setIsVistorPermission(false)
        }
    }, [viewVisitorBookPermission, updateVisitorFormSettingPermission])

    useEffect(() => {
        if (manageTaxRulePermission === false && manageEmployeePayrollPermission === false) {
            setIsPayrollPermission(false)
        }
    }, [manageTaxRulePermission, manageEmployeePayrollPermission])

    useEffect(() => {
        if (addMerchantPermission === false && manageMerchantPermission === false && viewCategoriesPermission === false &&
            addCategoriesPermission === false && viewItemPermission === false && addItemPermission === false &&
            manageItemPermission === false
        ) {
            setIsSuppliesPermission(false)
        }
    }, [addMerchantPermission, manageMerchantPermission, viewCategoriesPermission, addCategoriesPermission,
        viewItemPermission, addItemPermission, manageItemPermission
    ])

    const handleDeductionSubmitClick = () => {
        if (isDeductionTypeFixed === false && isDeductionTypePercent === false) {
            displayErrorToast('Deduction type not selected')
        } else if (isEmpty(deductionLabel)) {
            displayErrorToast('Deduction label cannot be blank')
        } else if (isEmpty(deductionValue)) {
            displayErrorToast('Deduction value cannot be blank')
        } else {
            setDeductionList(prevList => [
                ...prevList,
                {
                    type: isDeductionTypeFixed ? APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.FIXED : isDeductionTypePercent ? APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.PERCENT : '-',
                    key: deductionLabel,
                    value: parseFloat(deductionValue)
                }
            ])
            setIsDeductionTypeFixed(false)
            setIsDeductionTypePercent(false)
            setDeductionLabel('')
            setDeductionValue('')
        }
    }

    const handleDeductionChoiceType = (type) => {
        if (type === APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.FIXED) {
            setIsDeductionTypeFixed(true)
            setIsDeductionTypePercent(false)
        } else if (type === APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.PERCENT) {
            setIsDeductionTypeFixed(false)
            setIsDeductionTypePercent(true)
        }
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Add Employee' />
                <CommonFormBorder>
                    <SubTextLabel label='Enter details to add new employee' />
                    <FormFieldLabel className='up-bold-label' label='Employee Details' />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='text'
                            id='firstName'
                            onChange={e => setFirstName(e.target.value)}
                            placeholder='First Name'
                            value={firstName}
                        />
                        <CommonInputFloatHalf
                            type='text'
                            id='lastName'
                            onChange={e => setLastName(e.target.value)}
                            placeholder='Last Name'
                            value={lastName}
                        />
                    </CommonInputRow>
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='text'
                            id='personalEmail'
                            onChange={e => setPersonalEmail(e.target.value)}
                            placeholder='Personal Email'
                            value={personalEmail}
                        />
                        <div className="ae-phone-input-container">
                            <PhoneInput
                                defaultCountry="US"
                                placeholder="Mobile Number"
                                value={mobile}
                                onChange={setMobile} />
                        </div>
                    </CommonInputRow>
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='text'
                            id='employeeCode'
                            onChange={e => setEmployeeCode(e.target.value)}
                            placeholder='Employee Code'
                            value={employeeCode}
                        />
                        <CommonInputFloatHalf
                            type='text'
                            id='role'
                            onChange={e => setRole(e.target.value)}
                            placeholder='Employee Role'
                            value={role} />
                    </CommonInputRow>
                    <div className="pd-date-parent-container">
                        <FormFieldLabel label='Select Joining/Start Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={startDate}
                            onChange={(date) => {
                                setStartDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    <div className="ae-input-row-container">
                        <div className="ae-row-input-container">
                            <CommonInputFloatFull
                                type='text'
                                id='loginCode'
                                onChange={e => handleEmployeeLoginCodeChange(e)}
                                placeholder='Employee Login Code'
                                value={employeeLoginCode}
                                subText='Code to login on console'
                                isSubtext={true}
                            />
                        </div>
                        {!isEmpty(loginCodeCheckSuccess) && loginCodeCheckSuccess.data.isLoginCodeAvailable === true && <div className="ae-row-img-container">
                            <img src={require('../../../assets/ic_done_icon.png')} className="img" />
                        </div>}
                        <div className="ae-row-btn-container" onClick={() => { handleLoginCodeVerifyCheckClick() }}>Verify</div>
                    </div>
                    {isLoggedInUserBusiness(user) && <div>
                        <FormFieldLabel className='up-bold-label' label='Business Details' />
                        {isLoggedInUserBusiness(user) === true && <div>
                            <FormFieldLabel label='Select Business' />
                            {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedBusiness}
                                getOptionLabel={e => e.businessName}
                                getOptionValue={e => e}
                                options={userBusinessListSuccess.data}
                                placeholder='Select Business'
                                onChange={e => setSelectedBusiness(e)} />}
                            {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                        </div>}
                        {isLoggedInUserBusiness(user) === true && !isEmpty(selectedBusiness) && <div>
                            <FormFieldLabel label='Select Business Location' />
                            {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                                className='select-full-width-no-border'
                                value={selectedLocation}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e}
                                options={businessLocationListSuccess.data}
                                placeholder='Select Location'
                                onChange={e => setSelectedLocation(e)} />}
                            {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                        </div>}
                    </div>}
                    <FormFieldLabel className='up-bold-label' label='Additional Details' />
                    <Select
                        className='select-full-width-no-border'
                        value={employeeType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={employeeTypeList}
                        placeholder='Select Employee Type'
                        onChange={e => setEmployeeType(e)} />
                    <div className="ae-cb-row-container">
                        <div className="ae-phone-input-container">
                            <CommonCheckbox id='assignManager'
                                label='Assign Manager'
                                onChange={e => setIsAssignManagerCheck(e.target.checked)}
                                value={isAssignManagerCheck}
                            />
                        </div>
                        {isAssignManagerCheck === true && <div className="ae-select-btn-container" onClick={() => { handleSelectManagerClick() }}>Click To Select</div>}
                    </div>
                    {isAssignManagerCheck === true && !isEmpty(selectedManager) && <FormFieldLabel label='Selected Manager/Supervisor' />}
                    {isAssignManagerCheck === true && !isEmpty(selectedManager) && <div className="ae-emp-list-item-container">
                        <div className="ae-emp-list-item-content-container">
                            <div className="ae-emp-name-label">{selectedManager.firstName} {selectedManager.lastName}</div>
                            <div className="ae-emp-code-label">{selectedManager.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? selectedManager.employeeCode : ''}</div>
                            <div className="ae-emp-name-label">{selectedManager.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? selectedManager.role : ''}</div>
                        </div>
                    </div>}
                    <FormFieldLabel label='Salary Information' />
                    <CommonInputRow>
                        <CommonInputFloatHalf
                            type='text'
                            id='salary'
                            onChange={e => setEmployeeSalary(e.target.value)}
                            placeholder='Salary'
                            value={employeeSalary} />
                        <Select
                            menuPlacement='auto'
                            className='select-half-width'
                            value={employeeSalaryType}
                            getOptionLabel={e => e.value}
                            getOptionValue={e => e}
                            options={employeeSalaryTypeList}
                            placeholder='Select Salary Type'
                            onChange={e => setEmployeeSalaryType(e)} />
                    </CommonInputRow>
                    {!isEmpty(employeeSalaryType) && <CommonCheckbox
                        id='isDeductionApplicable'
                        label='Add Deduction'
                        value={isAddDeduction}
                        lableClass="ae-checkbox-label"
                        onChange={() => {
                            setIsAddDeduction(!isAddDeduction)
                        }}
                    />}
                    {isAddDeduction === true && <div>
                        <FormFieldLabel label='Select Deduction Type' />
                        <div className="ap-option-item-container mb-3">
                            <label className="ap-choice-label-container">
                                <input type='radio' value={APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.FIXED} checked={isDeductionTypeFixed} onChange={e => handleDeductionChoiceType(e.target.value)} />
                                <span className="ap-choice-label">Fixed Amount</span>
                            </label>
                            <label className="ap-choice-label-container">
                                <input type='radio' value={APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.PERCENT} checked={isDeductionTypePercent} onChange={e => handleDeductionChoiceType(e.target.value)} />
                                <span className="ap-choice-label">Percentage</span>
                            </label>
                        </div>
                        {isDeductionTypeFixed && <div className="ap-ti-parent-row-container">
                            <div className="ap-ti-input-container">
                                <CommonInputFloatHalf
                                    type='text'
                                    id='deductionKey'
                                    onChange={e => setDeductionLabel(e.target.value)}
                                    placeholder='Label'
                                    value={deductionLabel}
                                />
                                <CommonInputFloatHalf
                                    type='number'
                                    id='deductionValue'
                                    onChange={e => setDeductionValue(e.target.value)}
                                    placeholder='Amount'
                                    value={deductionValue}
                                />
                            </div>
                            <div className="ap-ti-button-label" onClick={() => handleDeductionSubmitClick()}>Add</div>
                        </div>}
                        {isDeductionTypePercent && <div className="ap-ti-parent-row-container">
                            <div className="ap-ti-input-container">
                                <CommonInputFloatHalf
                                    type='text'
                                    id='deductionKey'
                                    onChange={e => setDeductionLabel(e.target.value)}
                                    placeholder='Label'
                                    value={deductionLabel}
                                />
                                <PercentInputHalf
                                    onChange={e => setDeductionValue(e.target.value)}
                                    placeholder='Amount Percentage'
                                    value={deductionValue}
                                />
                            </div>
                            <div className="ap-ti-button-label" onClick={() => handleDeductionSubmitClick()}>Add</div>
                        </div>}
                        {!isEmpty(deductionList) && <div className="ap-ti-item-row-container">
                            {deductionList.map(e => (<div className="ap-ti-item-container">
                                {e.key} - {e.value} {e.type === APP_CONSTANTS.EMPLOYEE_SALARY_DEDUCTION_TYPE.PERCENT ? '%' : ''}
                            </div>))}
                        </div>}
                    </div>}
                    <FormFieldLabel label='Console Access Control/Permissions' />
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isLocationPermission}
                            value={isLocationPermission}
                            onChange={() => {
                                setIsLocationPermission(!isLocationPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Locations</label>
                    </div>
                    {isLocationPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewAllLocationPermission}
                                    value={viewAllLocationPermission}
                                    onChange={() => {
                                        setViewAllLocationPermission(!viewAllLocationPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View All Locations</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addLocationPermission}
                                    value={addLocationPermission}
                                    onChange={() => {
                                        setAddLocationPermission(!addLocationPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateLocationPermission}
                                    value={updateLocationPermission}
                                    onChange={() => {
                                        setUpdateLocationPermission(!updateLocationPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Details</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isEmployeePermission}
                            value={isEmployeePermission}
                            onChange={() => {
                                setIsEmployeePermission(!isEmployeePermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Employees</label>
                    </div>
                    {isEmployeePermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addEmployeePermission}
                                    value={addEmployeePermission}
                                    onChange={() => {
                                        setAddEmployeePermission(!addEmployeePermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={removeEmployeePermission}
                                    value={removeEmployeePermission}
                                    onChange={() => {
                                        setRemoveEmployeePermission(!removeEmployeePermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Remove Employee</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateEmployeePerPermission}
                                    value={updateEmployeePerPermission}
                                    onChange={() => {
                                        setUpdateEmployeePerPermission(!updateEmployeePerPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Details/Permissions</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isPayrollPermission}
                            value={isPayrollPermission}
                            onChange={() => {
                                setIsPayrollPermission(!isPayrollPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Payroll</label>
                    </div>
                    {isPayrollPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageTaxRulePermission}
                                    value={manageTaxRulePermission}
                                    onChange={() => {
                                        setManageTaxRulePermission(!manageTaxRulePermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Manage Tax Rules</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageEmployeePayrollPermission}
                                    value={manageEmployeePayrollPermission}
                                    onChange={() => {
                                        setManageEmployeePayrollPermission(!manageEmployeePayrollPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Empoyee Payroll</label>
                            </div>
                        </div>
                    </div>
                    }
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isProjectPermission}
                            value={isProjectPermission}
                            onChange={() => {
                                setIsProjectPermission(!isProjectPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Projects</label>
                    </div>
                    {isProjectPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addProjectPermission}
                                    value={addProjectPermission}
                                    onChange={() => {
                                        setAddProjectPermission(!addProjectPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateProjectPermission}
                                    value={updateProjectPermission}
                                    onChange={() => {
                                        setUpdateProjectPermission(!updateProjectPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewProjectCostingPermission}
                                    value={viewProjectCostingPermission}
                                    onChange={() => {
                                        setViewProjectCostingPermission(!viewProjectCostingPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Costing</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateProjectEmployeeRequestPermission}
                                    value={updateProjectEmployeeRequestPermission}
                                    onChange={() => {
                                        setUpdateProjectEmployeeRequestPermission(!updateProjectEmployeeRequestPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Employee Requests</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isShiftPermission}
                            value={isShiftPermission}
                            onChange={() => {
                                setIsShiftPermission(!isShiftPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Shifts</label>
                    </div>
                    {isShiftPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addShiftPermission}
                                    value={addShiftPermission}
                                    onChange={() => {
                                        setAddShiftPermission(!addShiftPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateShiftDetailsPermission}
                                    value={updateShiftDetailsPermission}
                                    onChange={() => {
                                        setUpdateShiftDetailPermission(!updateShiftDetailsPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Details</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateShiftEmployeeRequestPermission}
                                    value={updateShiftEmployeeRequestPermission}
                                    onChange={() => {
                                        setUpdateShiftEmployeeRequestPermission(!updateShiftEmployeeRequestPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Employee Requests</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isTaskPermission}
                            value={isTaskPermission}
                            onChange={() => {
                                setIsTaskPermission(!isTaskPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Tasks</label>
                    </div>
                    {isTaskPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addTaskPermission}
                                    value={addTaskPermission}
                                    onChange={() => {
                                        setAddTaskPermission(!addTaskPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={assignTaskPermission}
                                    value={assignTaskPermission}
                                    onChange={() => {
                                        setAssignTaskPermission(!assignTaskPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Assign Task</label>
                            </div>
                            <div className="col-sm-4">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={removeEmployeeTaskPermission}
                                    value={removeEmployeeTaskPermission}
                                    onChange={() => {
                                        setRemoveEmployeeTaskPermission(!removeEmployeeTaskPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Un-Assign Task</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isRequestPermission}
                            value={isRequestPermission}
                            onChange={() => {
                                setIsRequestPermission(!isRequestPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Requests</label>
                    </div>
                    {isRequestPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={acceptOrRejectRequestPermission}
                                    value={acceptOrRejectRequestPermission}
                                    onChange={() => {
                                        setAcceptOrRejectRequestPermission(!acceptOrRejectRequestPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Approve/Reject Request</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isDocumentPermission}
                            value={isDocumentPermission}
                            onChange={() => {
                                setIsDocumentPermission(!isDocumentPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Documents</label>
                    </div>
                    {isDocumentPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addDocumentPermission}
                                    value={addDocumentPermission}
                                    onChange={() => {
                                        setAddDocumentPermission(!addDocumentPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isPolicyPermission}
                            value={isPolicyPermission}
                            onChange={() => {
                                setIsPolicyPermission(!isPolicyPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Policies</label>
                    </div>
                    {isPolicyPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-12">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addPolicyPermission}
                                    value={addPolicyPermission}
                                    onChange={() => {
                                        setAddPolicyPermission(!addPolicyPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isAssetPermission}
                            value={isAssetPermission}
                            onChange={() => {
                                setIsAssetPermission(!isAssetPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Assets</label>
                    </div>
                    {isAssetPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewAllAssetsPermission}
                                    value={viewAllAssetsPermission}
                                    onChange={() => {
                                        setViewAllAssetsPermission(!viewAllAssetsPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View All</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addAssetPermission}
                                    value={addAssetPermission}
                                    onChange={() => {
                                        setAddAssetPermission(!addAssetPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={assignAssetPermission}
                                    value={assignAssetPermission}
                                    onChange={() => {
                                        setAssignAssetPermission(!assignAssetPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Assign Asset</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateAssetPermission}
                                    value={updateAssetPermission}
                                    onChange={() => {
                                        setUpdateAssetPermission(!updateAssetPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isAuditPermission}
                            value={isAuditPermission}
                            onChange={() => {
                                setIsAuditPermission(!isAuditPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Audit</label>
                    </div>
                    {isAuditPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewAllAuditPermission}
                                    value={viewAllAuditPermission}
                                    onChange={() => {
                                        setViewAllAuditPermission(!viewAllAuditPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View All</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={newAuditPermission}
                                    value={newAuditPermission}
                                    onChange={() => {
                                        setNewAuditPermission(!newAuditPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add New</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={assignAuditPermission}
                                    value={assignAuditPermission}
                                    onChange={() => {
                                        setAssignAuditPermission(!assignAuditPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Assign Audit</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateAuditStatusPermission}
                                    value={updateAuditStatusPermission}
                                    onChange={() => {
                                        setUpdateAuditPermission(!updateAuditStatusPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Status</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isVisitorPermission}
                            value={isVisitorPermission}
                            onChange={() => {
                                setIsVistorPermission(!isVisitorPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Visitor Book</label>
                    </div>
                    {isVisitorPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewVisitorBookPermission}
                                    value={viewVisitorBookPermission}
                                    onChange={() => {
                                        setViewVisitorBookPermission(!viewVisitorBookPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Book</label>
                            </div>
                            <div className="col-sm-6">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={updateVisitorFormSettingPermission}
                                    value={updateVisitorFormSettingPermission}
                                    onChange={() => {
                                        setUpdateVisitorFormSettingPermission(!updateVisitorFormSettingPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Update Entry Setting</label>
                            </div>
                        </div>
                    </div>}
                    <div>
                        <input
                            type="checkbox"
                            className="form-check-input input-text"
                            id="name"
                            checked={isSuppliesPermission}
                            value={isSuppliesPermission}
                            onChange={() => {
                                setIsSuppliesPermission(!isSuppliesPermission)
                            }}
                            required />
                        <label for="name" className="aemp-checkbox-label">Supplies</label>
                    </div>
                    {isSuppliesPermission === true && <div className="container mt-1 mb-1">
                        <div className="row">
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addMerchantPermission}
                                    value={addMerchantPermission}
                                    onChange={() => {
                                        setAddMerchantPermission(!addMerchantPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add Merchant</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageMerchantPermission}
                                    value={manageMerchantPermission}
                                    onChange={() => {
                                        setManageMerchantPermission(!manageMerchantPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Manage Merchant</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewCategoriesPermission}
                                    value={viewCategoriesPermission}
                                    onChange={() => {
                                        setViewCategoriesPermission(!viewCategoriesPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Categories</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addCategoriesPermission}
                                    value={addCategoriesPermission}
                                    onChange={() => {
                                        setAddCategoriesPermission(!addCategoriesPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add Category</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={viewItemPermission}
                                    value={viewItemPermission}
                                    onChange={() => {
                                        setViewItemPermission(!viewItemPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">View Supplies</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={addItemPermission}
                                    value={addItemPermission}
                                    onChange={() => {
                                        setAddItemPermission(!addItemPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Add Supplies</label>
                            </div>
                            <div className="col-sm-3">
                                <input
                                    type="checkbox"
                                    className="form-check-input input-text"
                                    id="name"
                                    checked={manageItemPermission}
                                    value={manageItemPermission}
                                    onChange={() => {
                                        setManageItemPermission(!manageItemPermission)
                                    }}
                                    required />
                                <label for="name" className="aemp-checkbox-label aemp-checkbox-label-black">Manage Supplies</label>
                            </div>
                        </div>
                    </div>}
                    <ButtonRow>
                        <CommonButton label='Submit'
                            onClick={() => { handleSubmitClick() }}
                            isBig={true} />
                    </ButtonRow>
                </CommonFormBorder>
            </CommonScreenContent>
            <Modal
                onHide={() => { setAddEmployeeSuccessModel(false) }}
                show={addEmployeeSuccessModel}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {!isEmpty(addEmployeeSuccess) && <div className="ae-model">
                        <div className="ae-model-img-container">
                            <img src={require('../../../assets/ic_success_img.png')} className="img" />
                        </div>
                        <div className="ae-model-message">{addEmployeeSuccess?.data?.message}</div>
                        <div className="ae-model-sub-message">Temporary Password to login on console</div>
                        <div className="ae-model-text">{addEmployeeSuccess?.data?.tempPassword}</div>
                    </div>}
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowEmployeeModal(false) }}
                show={showEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select Manager/Supervisor
                </Modal.Header>
                <Modal.Body>
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedManager(e)
                                setShowEmployeeModal(false)
                            }}>Select</div>
                        </div>))}
                    </div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign Self' onClick={() => {
                            setSelectedManager(user.data.userDetails)
                            setShowEmployeeModal(false)
                        }} />
                    </div>
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AddEmployee